import {
    GET_ASSET_READINESS_WORK_BOOK_GRID,
    SET_ASSET_READINESS_WORK_BOOK_GRID,
    GET_SAVE_ASSET_READINESS_WORK_BOOK,
    SET_SAVE_ASSET_READINESS_WORK_BOOK,
    GET_AUDIT_DATE_LIST,
    SET_AUDIT_DATE_LIST,
    GET_AUDIT_READINESS_DATE_LIST,
    SET_AUDIT_READINESS_DATE_LIST,
    GET_AUDIT_TRAINING_DATE_LIST,
    SET_AUDIT_TRAINING_DATE_LIST,
    IS_DROP_DOWNS_LOADING,
    SET_IS_WORKBOOK_GRID_BIND_ONLOAD,
    SET_ASSET_READINESS_WORK_BOOK_FILTER,
    GET_CURRENT_AUDIT_CYCLE,
    SET_CURRENT_AUDIT_CYCLE
} from "./AuditReadinessworkBookType"

const getAssetReadinessWorkBookGrid = (payload?: any) => ({
    type: GET_ASSET_READINESS_WORK_BOOK_GRID,
    payload
});

const setAssetReadinessWorkBookGrid = (readinessWorkBookGrid: any) => ({
    type: SET_ASSET_READINESS_WORK_BOOK_GRID,
    readinessWorkBookGrid: readinessWorkBookGrid
});

const getSaveAssetReadinessWorkBook = (payload?: any) => ({
    type: GET_SAVE_ASSET_READINESS_WORK_BOOK,
    payload
});

const setSaveAssetReadinessWorkBook = (isSaveAssetReadinessWorkBook: any) => ({
    type: SET_SAVE_ASSET_READINESS_WORK_BOOK,
    isSaveAssetReadinessWorkBook: isSaveAssetReadinessWorkBook
});

const getAuditDateList = () => ({
    type : GET_AUDIT_DATE_LIST
});

const setAuditDateList = (auditDateDropDown : any) => ({
    type : SET_AUDIT_DATE_LIST,
    auditDateDropDown : auditDateDropDown
});

const getAuditReadinessDateList = () => ({
    type : GET_AUDIT_READINESS_DATE_LIST
});

const setAuditReadinessDateList = (auditReadinessDateDropDown : any) => ({
    type : SET_AUDIT_READINESS_DATE_LIST,
    auditReadinessDateDropDown : auditReadinessDateDropDown
});

const getAuditTrainingDateList = () => ({
    type : GET_AUDIT_TRAINING_DATE_LIST
});

const setAuditTrainingDateList = (auditTrainingDateDropDown : any) => ({
    type : SET_AUDIT_TRAINING_DATE_LIST,
    auditTrainingDateDropDown : auditTrainingDateDropDown
});

const setIsDropDownsLoading = (flag: boolean) => ({
    type: IS_DROP_DOWNS_LOADING,
    flag
});

const setIsWorkBookGridBindOnload = (isWorkBookGridBindOnload: any) => ({
    type: SET_IS_WORKBOOK_GRID_BIND_ONLOAD,
    isWorkBookGridBindOnload: isWorkBookGridBindOnload
});

const setAssetReadinessWorkBookFilter = (assetReadinessWorkBookFilter: any) => ({
    type: SET_ASSET_READINESS_WORK_BOOK_FILTER,
    assetReadinessWorkBookFilter: assetReadinessWorkBookFilter
});

const getCurrentAuditCycle = () => ({
    type : GET_CURRENT_AUDIT_CYCLE
});

const setCurrentAuditCycle = (auditCycle : any) => ({
    type : SET_CURRENT_AUDIT_CYCLE,
    auditCycle : auditCycle
});


export {
    getAssetReadinessWorkBookGrid,
    setAssetReadinessWorkBookGrid,
    getSaveAssetReadinessWorkBook,
    setSaveAssetReadinessWorkBook,
    getAuditDateList,
    setAuditDateList,
    getAuditReadinessDateList,
    setAuditReadinessDateList,
    getAuditTrainingDateList,
    setAuditTrainingDateList,
    setIsDropDownsLoading,
    setIsWorkBookGridBindOnload,
    setAssetReadinessWorkBookFilter,
    getCurrentAuditCycle,
    setCurrentAuditCycle
}
